import React from "react";
import { InlineMath } from "react-katex";
import { makeSimpleClosedTask, normalizeMay2026Variant } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
import { getProjectileData } from "./MaturaMay2026ProjectileData";

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const data = getProjectileData(variant === "original");
  const answer = `t=${String(data.vertex).replace(".","{,}")}\\text{ s}`;
  return makeSimpleClosedTask({
    type: "MaturaProjectileVertexTimeClosedTask",
    taskNumber: "33.2",
    variant,
    prompt: <span>Wysokość piłeczki opisuje funkcja <InlineMath math={`h(t)=${String(data.a).replace(".","{,}")}t^2+${String(data.b).replace(".","{,}")}t`}/>. Największą wysokość osiągnie w chwili:</span>,
    correct: answer,
    wrong: [`t=${data.vertex+1}\\text{ s}`, `t=${Math.max(.5,data.vertex-.5)}\\text{ s}`, `t=${data.vertex+.5}\\text{ s}`],
    tags: ["funkcja kwadratowa", "zastosowania"],
    explanationSteps: [{ title: "Maksimum jest osiągane w wierzchołku paraboli.", latex: `t_w=-\\frac{b}{2a}=-\\frac{${data.b}}{2\\cdot(${data.a})}=${data.vertex}\\text{ s}` }],
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
